import { Anchor } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type BackLinkProps = {
  to: string;
  label?: string;
};

export const BackLink: React.FC<BackLinkProps> = ({ to, label }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Anchor
      component="button"
      onClick={() => navigate(to)}
      c="dimmed"
      size="sm"
      mb="xs"
      style={{ display: 'flex', alignItems: 'center', gap: 4 }}
    >
      <IconArrowLeft size={14} />
      {label || t('common.back')}
    </Anchor>
  );
};
